// hooks/useDateRange.js
import { useState } from 'react';
import moment from 'moment';

const useDateRange = (defaultToToday = true) => {
    const [startDate, setStartDate] = useState(
        defaultToToday ? moment.utc().startOf('day') : moment.utc().subtract(7, 'days').startOf('day')
    );
    const [endDate, setEndDate] = useState(moment.utc().endOf('day'));

    const handleDateChange = ({ startDate: newStart, endDate: newEnd }) => {
        if (newStart && newEnd) {
            setStartDate(newStart);
            setEndDate(newEnd);
        } else {
            setStartDate(moment.utc().startOf('day'));
            setEndDate(moment.utc().endOf('day'));
        }
    };

    const resetToToday = () => {
        setStartDate(moment.utc().startOf('day'));
        setEndDate(moment.utc().endOf('day'));
    };

    const resetToLastWeek = () => {
        setStartDate(moment.utc().subtract(7, 'days').startOf('day'));
        setEndDate(moment.utc().endOf('day'));
    };

    return {
        startDate,
        endDate,
        dateRange: { startDate, endDate },
        handleDateChange,
        resetToToday,
        resetToLastWeek,
        setStartDate,
        setEndDate
    };
};

export default useDateRange;